/**
 * Validates password according to the following rules:
 * - At least 6 characters long
 * - At least one uppercase letter (including Swedish Å, Ä, Ö)
 * - At least one digit
 *
 * @param password - The password to validate
 * @returns true if password is valid, false otherwise
 */
export const validatePassword = (password: string): boolean => {
    const passwordRegex = /^(?=.*[A-ZÅÄÖ])(?=.*\d).{6,}$/;
    return passwordRegex.test(password);
};

/**
 * Gets a user-friendly error message for invalid passwords
 *
 * @returns Error message describing password requirements
 */
export const getPasswordRequirementsMessage = (): string => {
    return 'Lösenordet måste vara minst 6 tecken långt och innehålla minst en stor bokstav och en siffra.';
};
